import React, { useCallback } from 'react';
import Notiflix from 'notiflix';
import { SharedCard } from './types';
import SharedWithList from './SharedWithList';
import { SharedCardItem as StyledSharedCardItem } from './styles';

interface SharedCardItemProps {
  card: SharedCard;
  onUpdateCard: (updatedCard: SharedCard) => void;
  onDeleteSharing?: (token: string) => Promise<void>;
}

const SharedCardItem: React.FC<SharedCardItemProps> = ({
  card,
  onUpdateCard,
  onDeleteSharing,
}) => {
  const handleRemovePerson = useCallback(
    async (personId: string) => {
      const personToRemove = card.sharedWith.find((p) => p.id === personId);

      if (personToRemove) {
        Notiflix.Confirm.show(
          'Remover Compartilhamento',
          `Tem certeza que deseja remover ${personToRemove.name} do compartilhamento deste cartão?`,
          'Remover',
          'Cancelar',
          async () => {
            try {
              if (onDeleteSharing) {
                await onDeleteSharing(personId);

                Notiflix.Notify.success(
                  `${personToRemove.name} foi removido do compartilhamento`,
                );

                const updatedSharedWith = card.sharedWith.filter(
                  (person) => person.id !== personId,
                );

                onUpdateCard({
                  ...card,
                  sharedWith: updatedSharedWith,
                });
              } else {
                const updatedSharedWith = card.sharedWith.filter(
                  (person) => person.id !== personId,
                );

                onUpdateCard({
                  ...card,
                  sharedWith: updatedSharedWith,
                });

                Notiflix.Notify.success(
                  `${personToRemove.name} foi removido do compartilhamento`,
                );
              }
            } catch (error) {
              Notiflix.Notify.failure(
                'Erro ao remover compartilhamento. Tente novamente.',
              );
              console.error('Erro ao remover compartilhamento:', error);
            }
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          () => {},
          {
            width: '320px',
            borderRadius: '10px',
            titleColor: '#0A5F55',
            okButtonBackground: '#00995D',
            cancelButtonBackground: '#5B5C65',
          },
        );
      }
    },
    [card, onUpdateCard, onDeleteSharing],
  );

  return (
    <StyledSharedCardItem>
      <SharedWithList
        sharedWith={card.sharedWith}
        onRemovePerson={handleRemovePerson}
      />
    </StyledSharedCardItem>
  );
};

export default SharedCardItem;
